
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { formMixin, formOptionsMixin, formValidationMixin } from "../mixins";
import Select from "./Select.vue";
import { getModule } from "vuex-module-decorators";
import BarcodeCompanyModule from "@/store/modules/barcodeSystem/barcodeCompany";
import BarcodeManufacturerModule from "@/store/modules/barcodeSystem/barcodeManufacturer";
import { CompanyResource } from "@/models/api/barcodeSystem/barcodeCompanies/get";

const barcodeCompanyModuleState = getModule(BarcodeCompanyModule);
const barcodeManufacturerModuleState = getModule(BarcodeManufacturerModule);

@Component({
  components: {
    Select
  }
})
export default class BarcodeCompanySelect extends Mixins(
  formMixin,
  formOptionsMixin,
  formValidationMixin
) {
  @Prop({ default: false })
  appendToBody: boolean;
  @Prop()
  type: string;
  @Prop()
  currentFacilityCode: string;
  @Prop({ default: false })
  manualStockOrdersOnly: boolean;
  localCompanies: CompanyResource[] = null;

  get companies()
  {
    return barcodeCompanyModuleState.companies;
  }

  get manualStockOrdersCompanyIds(): number[] {
    return (barcodeManufacturerModuleState.manufacturers || [])
      .filter(x => x.allowManualStockOrdersCreation)
      .reduce((ids, x) => ids.concat(x.companyIds || []), [] as number[]);
  }

  created() {
    this.localCompanies = JSON.parse(JSON.stringify(this.companies));
  }

  get types() {
    let companies = this.currentFacilityCode
      ? this.localCompanies.filter(x => x.facilityCodes.includes(this.currentFacilityCode))
      : this.localCompanies;

    if (this.manualStockOrdersOnly)
      companies = companies.filter(x => this.manualStockOrdersCompanyIds.includes(x.id));

    return companies.map(x => ({ label: `${x.companyName}`, value: x.id }));
  }

  @Watch('currentFacilityCode')
  onCurrentFacilityCodeChanged(val: string, oldVal: string)
  {
    if(val != oldVal)
    {
      this.localValue = null;
    }
  }
}
